(() => {
  const script = document.currentScript;
  const iconUrl = script && script.dataset.nlWhatsappIcon;
  const floatingElements = new Set();
  let collisionFrame;

  if (!iconUrl) return;

  const getFloatingElement = (icon) => {
    let element = icon;

    while (element && element !== document.body) {
      const styles = window.getComputedStyle(element);
      const bounds = element.getBoundingClientRect();

      if (styles.position === 'fixed' && bounds.width <= 240 && bounds.height <= 240) return element;
      element = element.parentElement;
    }

    return icon.closest('a, button, [role="button"]') || icon;
  };

  const keepClearOfFixedElements = () => {
    collisionFrame = undefined;
    const footer = document.querySelector('.nl-footer-bottom');
    const stickyWrapper = document.querySelector('.template-product animate-sticky.sticky-cart-wrapper');
    const stickyCart = stickyWrapper && stickyWrapper.querySelector('.product-sticky-cart');
    const footerBounds = footer && footer.getBoundingClientRect();
    const footerIsVisible = Boolean(
      footerBounds
      && footerBounds.top < window.innerHeight
      && footerBounds.bottom > 0
    );
    const stickyHeight = stickyCart ? stickyCart.offsetHeight : 0;

    if (stickyWrapper) {
      stickyWrapper.classList.remove('nl-sticky-cart--clear-footer');
      document.documentElement.style.setProperty('--nl-product-sticky-height', `${stickyHeight}px`);
    }

    floatingElements.forEach((element) => {
      element.style.setProperty('--nl-whatsapp-footer-shift', '0px');

      if (!element.isConnected) return;

      const elementBounds = element.getBoundingClientRect();
      const obstacles = [];

      if (footerIsVisible) obstacles.push(footerBounds);

      if (stickyCart && stickyWrapper.hasAttribute('animate')) {
        if (stickyHeight > 0) {
          obstacles.push({
            top: window.innerHeight - stickyHeight,
            right: window.innerWidth,
            bottom: window.innerHeight,
            left: 0
          });
        }
      }

      const blockingTops = obstacles
        .filter((bounds) => (
          elementBounds.bottom > bounds.top
          && elementBounds.top < bounds.bottom
          && elementBounds.right > bounds.left
          && elementBounds.left < bounds.right
        ))
        .map((bounds) => bounds.top);

      if (blockingTops.length === 0) return;

      const shift = Math.ceil(elementBounds.bottom - Math.min(...blockingTops) + 12);
      element.style.setProperty('--nl-whatsapp-footer-shift', `-${shift}px`);
    });
  };

  const scheduleCollisionCheck = () => {
    if (collisionFrame) return;
    collisionFrame = window.requestAnimationFrame(keepClearOfFixedElements);
  };

  const applyWhiteIcon = () => {
    document.querySelectorAll('img[src*="cdn.live.zoko.io"]').forEach((icon) => {
      const source = icon.getAttribute('src') || '';

      if (!/whatsapp/i.test(source) && icon.dataset.nlWhatsappIcon !== 'true') return;

      if (source !== iconUrl) icon.setAttribute('src', iconUrl);
      icon.dataset.nlWhatsappIcon = 'true';
      icon.classList.add('nl-whatsapp-float__icon');
      icon.alt = 'Contactar por WhatsApp';

      const floatingElement = getFloatingElement(icon);
      floatingElement.classList.add('nl-whatsapp-float');
      floatingElements.add(floatingElement);
    });

    scheduleCollisionCheck();
  };

  applyWhiteIcon();

  const observer = new MutationObserver(applyWhiteIcon);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src']
  });

  window.addEventListener('scroll', scheduleCollisionCheck, { passive: true });
  window.addEventListener('resize', scheduleCollisionCheck);
})();
